<template>
    <div>
        <Banner :banners="banners" show-overlay> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper">
            <h2 class="title text-center">分眾導覽好好玩</h2>
            <p class="text-sm pb-4">
                不論是情侶、家庭出遊、自己一個小旅行，都可以自由自在地遊玩臺中綠柳川一帶。整治過後的綠柳川,除了成為城市中會呼吸的河，供民眾嬉戲遊玩以外，周邊也發展出了許多有趣的特色商家及美食，來到大臺中，千萬別錯過了。
            </p>

            <div class="detail-card tour green mb-4">
                <div class="card-body">
                    <div class="d-flex align-items-center mb-2">
                        <button
                            class="btn btn-how ml-auto flex-shrink-0 align-self-baseline px-2"
                            @click="goTour('family')"
                        >
                            親子推薦
                        </button>
                    </div>
                    <vue-load-image class="mb-2">
                        <img
                            slot="image"
                            :src="familyPhoto"
                            class="detail-img"
                            alt="親子共遊"
                        />
                        <img slot="preloader" src="@/assets/image-loader.gif" class="w-100" />
                        <img
                            slot="error"
                            class="border d-block detail-img"
                            src=""
                            alt="not found"
                        />
                    </vue-load-image>
                    <div class="title green text-center">
                        親子共遊半日遊推薦
                    </div>
                </div>
            </div>
            <div class="detail-card tour  mb-4">
                <div class="card-body">
                    <div class="d-flex align-items-center mb-2">
                        <button
                            class="btn btn-how ml-auto flex-shrink-0 align-self-baseline px-2"
                            @click="goTour('couple')"
                        >
                            情侶推薦
                        </button>
                    </div>
                    <vue-load-image class="mb-2">
                        <img
                            slot="image"
                            :src="couplePhoto"
                            class="detail-img"
                            alt="浪漫遊柳川"
                        />
                        <img slot="preloader" src="@/assets/image-loader.gif" class="w-100" />
                        <img
                            slot="error"
                            class="border d-block detail-img"
                            src=""
                            alt="not found"
                        />
                    </vue-load-image>
                    <div class="title red text-center">
                        浪漫遊柳川半日遊推薦
                    </div>
                </div>
            </div>
            <div class="detail-card tour blue mb-4">
                <div class="card-body">
                    <div class="d-flex align-items-center mb-2">
                        <button
                            class="btn btn-how ml-auto flex-shrink-0 align-self-baseline px-2"
                            @click="goTour('culture')"
                        >
                            文藝推薦
                        </button>
                    </div>
                    <vue-load-image class="mb-2">
                        <img
                            slot="image"
                            :src="culturePhoto"
                            class="detail-img"
                            alt="文藝遊柳川"
                        />
                        <img slot="preloader" src="@/assets/image-loader.gif" class="w-100" />
                        <img
                            slot="error"
                            class="border d-block detail-img"
                            src=""
                            alt="not found"
                        />
                    </vue-load-image>
                    <div class="title blue text-center">
                        文藝遊柳川半日遊推薦
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/guide_tour_img.jpg'),
                },
            ],
            couplePhoto: require('@/assets/couple_img.jpg'),
            familyPhoto: require('@/assets/culture_img.jpg'),
            culturePhoto: require('@/assets/family_img.jpg'),
        };
    },
    mounted() {},
    methods: {
        goTour(link) {
            this.$router.push(`${this.$route.path}/${link}`);
        },
    },
    components: {
        Banner,
        Breadcrumb,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
